/**
 * RBAC permission slugs for the Documents module.
 * Keep in sync with backend permissionSeeds.js and route guards.
 */
export const DOCUMENT_PERMISSIONS = {
  UPLOAD: "documents.upload",
  VIEW: "documents.view",
  EDIT: "documents.edit",
  DELETE: "documents.delete",
};
